import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  // Hidden until authentic YOGA PRÊT reviews are added in data/content.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-275" data-mp="3fyw0wi9pvres">
      <div className="mx-auto max-w-6xl" data-id="element-276" data-mp="3azjd9vb0ugb5">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-277" data-mp="3ayhzvk6j9hq9">
          Ce que disent <em className="text-red-700" data-id="element-278" data-mp="32060otrlpbm7">les professeurs</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-279" data-mp="321z8wdhv43wb">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-280" data-mp="2s1qact0ee6dr">
              <div className="text-sm text-amber-500" aria-label="5 sur 5 étoiles" data-id="element-281" data-mp="2s3jfu4z9ykk6">
                <span aria-hidden="true" data-id="element-282" data-mp="v8wsy8so9ic6">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-283" data-mp="qa3qrciu5drb">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-284" data-mp="h8ax9aoyulpn">
                <span className="font-semibold text-slate-900" data-id="element-285" data-mp="m62soeotkpyl">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-286" data-mp="78k35a4bi8q3"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}